import type { FieldsProps } from './Fields/types';

// const maxDate = new Date().toISOString().slice(0, 10);
// const minDate = `${+maxDate.slice(0, 4) - 100}${maxDate.slice(4)}`;

export default [
  [
    {
      placeholder: { en: 'Name', ar: 'الاسم' },
      name: 'firstName',
      required: true,
      width: 100
    },
    {
      placeholder: { en: 'Name', ar: 'الاسم' },
      name: 'lastName',
      required: true,
      width: 100
    },
    {
      pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
      placeholder: { en: 'example@mail.com', ar: 'example@mail.com' },
      name: 'emailAddress',
      required: true,
      type: 'email',
      width: 100
    },
    {
      placeholder: { en: '+971 5X XXX XXXX', ar: '+971 5X XXX XXXX' },
      pattern: /^(\+971[0-9]{9}$)/,
      name: 'phoneNumber',
      required: true,
      type: 'tel',
      width: 100
    },
    {
      placeholder: { en: 'Select Nationality', ar: 'اختر الجنسية' },
      name: 'nationality',
      required: true,
      type: 'select',
      search: false,
      width: 100,
      options: [
        { "value": "AE", "emoji": "🇦🇪", "nameEN": "Emirati", "nameAR": "إماراتي" },
        { "value": "IN", "emoji": "🇮🇳", "nameEN": "Indian", "nameAR": "هندي" },
        { "value": "PK", "emoji": "🇵🇰", "nameEN": "Pakistani", "nameAR": "باكستاني" },
        { "value": "BD", "emoji": "🇧🇩", "nameEN": "Bangladeshi", "nameAR": "بنغلاديشي" },
        { "value": "PH", "emoji": "🇵🇭", "nameEN": "Filipino", "nameAR": "فلبيني" },
        { "value": "DZ", "emoji": "🇩🇿", "nameEN": "Algerian", "nameAR": "جزائري" },
        { "value": "US", "emoji": "🇺🇸", "nameEN": "American", "nameAR": "أمريكي" },
        { "value": "AR", "emoji": "🇦🇷", "nameEN": "Argentine", "nameAR": "أرجنتيني" },
        { "value": "AU", "emoji": "🇦🇺", "nameEN": "Australian", "nameAR": "أسترالي" },
        { "value": "AT", "emoji": "🇦🇹", "nameEN": "Austrian", "nameAR": "نمساوي" },
        { "value": "BH", "emoji": "🇧🇭", "nameEN": "Bahraini", "nameAR": "بحريني" },
        { "value": "BE", "emoji": "🇧🇪", "nameEN": "Belgian", "nameAR": "بلجيكي" },
        { "value": "BR", "emoji": "🇧🇷", "nameEN": "Brazilian", "nameAR": "برازيلي" },
        { "value": "GB", "emoji": "🇬🇧", "nameEN": "British", "nameAR": "بريطاني" },
        { "value": "CA", "emoji": "🇨🇦", "nameEN": "Canadian", "nameAR": "كندي" },
        { "value": "CL", "emoji": "🇨🇱", "nameEN": "Chilean", "nameAR": "تشيلي" },
        { "value": "CN", "emoji": "🇨🇳", "nameEN": "Chinese", "nameAR": "صيني" },
        { "value": "CO", "emoji": "🇨🇴", "nameEN": "Colombian", "nameAR": "كولومبي" },
        { "value": "CZ", "emoji": "🇨🇿", "nameEN": "Czech", "nameAR": "تشيكي" },
        { "value": "DK", "emoji": "🇩🇰", "nameEN": "Danish", "nameAR": "دنماركي" },
        { "value": "NL", "emoji": "🇳🇱", "nameEN": "Dutch", "nameAR": "هولندي" },
        { "value": "EG", "emoji": "🇪🇬", "nameEN": "Egyptian", "nameAR": "مصري" },
        { "value": "ET", "emoji": "🇪🇹", "nameEN": "Ethiopian", "nameAR": "إثيوبي" },
        { "value": "FI", "emoji": "🇫🇮", "nameEN": "Finnish", "nameAR": "فنلندي" },
        { "value": "FR", "emoji": "🇫🇷", "nameEN": "French", "nameAR": "فرنسي" },
        { "value": "DE", "emoji": "🇩🇪", "nameEN": "German", "nameAR": "ألماني" },
        { "value": "GH", "emoji": "🇬🇭", "nameEN": "Ghanaian", "nameAR": "غاني" },
        { "value": "GR", "emoji": "🇬🇷", "nameEN": "Greek", "nameAR": "يوناني" },
        { "value": "HU", "emoji": "🇭🇺", "nameEN": "Hungarian", "nameAR": "مجري" },
        { "value": "ID", "emoji": "🇮🇩", "nameEN": "Indonesian", "nameAR": "إندونيسي" },
        { "value": "IQ", "emoji": "🇮🇶", "nameEN": "Iraqi", "nameAR": "عراقي" },
        { "value": "IT", "emoji": "🇮🇹", "nameEN": "Italian", "nameAR": "إيطالي" },
        { "value": "JP", "emoji": "🇯🇵", "nameEN": "Japanese", "nameAR": "ياباني" },
        { "value": "JD", "emoji": "🇯🇴", "nameEN": "Jordanian", "nameAR": "أردني" },
        { "value": "KE", "emoji": "🇰🇪", "nameEN": "Kenyan", "nameAR": "كيني" },
        { "value": "KW", "emoji": "🇰🇼", "nameEN": "Kuwaiti", "nameAR": "كويتي" },
        { "value": "LB", "emoji": "🇱🇧", "nameEN": "Lebanese", "nameAR": "لبناني" },
        { "value": "LY", "emoji": "🇱🇾", "nameEN": "Libyan", "nameAR": "ليبي" },
        { "value": "MY", "emoji": "🇲🇾", "nameEN": "Malaysian", "nameAR": "ماليزي" },
        { "value": "MA", "emoji": "🇲🇦", "nameEN": "Moroccan", "nameAR": "مغربي" },
        { "value": "NP", "emoji": "🇳🇵", "nameEN": "Nepalese", "nameAR": "نيبالي" },
        { "value": "NG", "emoji": "🇳🇬", "nameEN": "Nigerian", "nameAR": "نيجيري" },
        { "value": "NZ", "emoji": "🇳🇿", "nameEN": "New Zealander", "nameAR": "نيوزيلندي" },
        { "value": "ND", "emoji": "🇳🇴", "nameEN": "Norwegian", "nameAR": "نرويجي" },
        { "value": "OM", "emoji": "🇴🇲", "nameEN": "Omani", "nameAR": "عُماني" },
        { "value": "PS", "emoji": "🇵🇸", "nameEN": "Palestinian", "nameAR": "فلسطيني" },
        { "value": "PE", "emoji": "🇵🇪", "nameEN": "Peruvian", "nameAR": "بيروفي" },
        { "value": "PT", "emoji": "🇵🇹", "nameEN": "Portuguese", "nameAR": "برتغالي" },
        { "value": "QA", "emoji": "🇶🇦", "nameEN": "Qatari", "nameAR": "قطري" },
        { "value": "RO", "emoji": "🇷🇴", "nameEN": "Romanian", "nameAR": "روماني" },
        { "value": "RU", "emoji": "🇷🇺", "nameEN": "Russian", "nameAR": "روسي" },
        { "value": "SA", "emoji": "🇸🇦", "nameEN": "Saudi", "nameAR": "سعودي" },
        { "value": "SD", "emoji": "🇸🇩", "nameEN": "Sudanese", "nameAR": "سوداني" },
        { "value": "ZA", "emoji": "🇿🇦", "nameEN": "South African", "nameAR": "جنوب أفريقي" },
        { "value": "KR", "emoji": "🇰🇷", "nameEN": "Korean", "nameAR": "كوري" },
        { "value": "ES", "emoji": "🇪🇸", "nameEN": "Spanish", "nameAR": "إسباني" },
        { "value": "LK", "emoji": "🇱🇰", "nameEN": "Sri Lankan", "nameAR": "سريلانكي" },
        { "value": "SE", "emoji": "🇸🇪", "nameEN": "Swedish", "nameAR": "سويدي" },
        { "value": "CH", "emoji": "🇨🇭", "nameEN": "Swiss", "nameAR": "سويسري" },
        { "value": "SY", "emoji": "🇸🇾", "nameEN": "Syrian", "nameAR": "سوري" },
        { "value": "TH", "emoji": "🇹🇭", "nameEN": "Thai", "nameAR": "تايلاندي" },
        { "value": "TN", "emoji": "🇹🇳", "nameEN": "Tunisian", "nameAR": "تونسي" },
        { "value": "TR", "emoji": "🇹🇷", "nameEN": "Turkish", "nameAR": "تركي" },
        { "value": "VN", "emoji": "🇻🇳", "nameEN": "Vietnamese", "nameAR": "فيتنامي" },
        { "value": "YE", "emoji": "🇾🇪", "nameEN": "Yemeni", "nameAR": "يمني" },
        { "value": "WW", "emoji": "🌍", "nameEN": "Other", "nameAR": "أخرى" }
      ]
    },
    {
      placeholder: { en: '784-XXXX-XXXXXXX-X', ar: '784-XXXX-XXXXXXX-X' },
      pattern: /^(784[0-9]{12}$)/,
      name: 'idNumber',
      required: true,
      type: 'number',
      width: 100
    }
    /* {
      name: 'dateBirth',
      required: true,
      type: 'date',
      min: minDate,
      max: maxDate,
      width: 100
    },
    {
      placeholder: 'Your message...',
      name: 'textArea',
      required: false,
      maxLength: 250,
      type: 'area',
      width: 100,
      rows: 20
    }
  ],
  [
    {
      pattern: /^[0-9]{4}\s?[a-zA-Z]{2}$/,
      name: 'postalCode',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      pattern: /^\d+$/,
      name: 'houseNumber',
      placeholder: '',
      required: true,
      width: 48
    },
    {
      pattern: /^[a-zA-Z0-9]{1,5}$/,
      placeholder: '',
      name: 'suffix',
      width: 48
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      name: 'streetName',
      placeholder: '',
      required: true,
      width: 100
    },
    {
      pattern: /^[^-\s][\w.,\s\\'-]+$/,
      placeholder: '',
      required: true,
      name: 'venue',
      width: 100
    } */
  ]
] as FieldsProps;
